import React from 'react'
import styles from './styles.module.css'
import Quill from 'react-quill'


export default function Input ({label, ...props}) {
  return (
    <label className={styles.label}>
        <p>{label}</p>
        <Quill {...props}/>
    </label>
  )
}
